import { render, staticRenderFns } from "./ServicesContent.vue?vue&type=template&id=71dc7bff&scoped=true&"
import script from "./ServicesContent.vue?vue&type=script&lang=js&"
export * from "./ServicesContent.vue?vue&type=script&lang=js&"
import style0 from "./ServicesContent.vue?vue&type=style&index=0&id=71dc7bff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc7bff",
  null
  
)

export default component.exports